import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currenc'
})
export class CurrencyPipe implements PipeTransform {

  transform(value: any, args?: any): any {


  }

}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/currency.pipe.ts